import features from 'common/features';

features.init(window.__FEATURES__);



// WEBPACK FOOTER //
// ./client/features.es6